module.exports = __webpack_public_path__ + "static/media/RBG_art_Jacob_Myrick.1244b359.mp4";